 export default  class HistoryWarningListBox {
    constructor($state,$stateParams,warningService){
        this.stateParams = $stateParams
        this.state = $state
        this.service = warningService;

        this.termsStr = this.stateParams.terms

        this.terms = JSON.parse(this.termsStr)
    }




}

HistoryWarningListBox.$inject = ['$state','$stateParams','warningService']